import { ChevronLeft } from "@mui/icons-material";
import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo_no_background.png";
import { Alert, AlertDescription } from "../components/ui/alert";
import { Button } from "../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../components/ui/card";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import recoverPassword from "../services/recover-password.service";

export default function ForgotPassword() {
  const [email, setEmail] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setIsLoading(true);
    recoverPassword(email)
      .then((x) => {
        setShowAlert(true);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100">
      {/* Header with back button */}
      <div className="p-2 sm:p-4 md:p-6">
        <Link to="/">
          <Button
            variant="ghost"
            className="text-gray-600 hover:text-gray-900 p-0"
          >
            <ChevronLeft className="w-5 h-5 mr-1" />
            Voltar
          </Button>
        </Link>
      </div>

      {/* Main content */}
      <div className="flex-1 flex items-center justify-center p-2 sm:p-4">
        <div className="w-full max-w-md space-y-8">
          {/* Logo */}
          <div className="flex justify-center">
            <div className="w-60 h-60 rounded-full bg-[#24324D] p-4 flex items-center justify-center">
              <img
                src={logo}
                alt="Logo"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Recovery Card */}
          <Card className="shadow-lg border-0 bg-white/80 backdrop-blur-sm">
            <CardHeader className="space-y-1 text-center">
              <CardTitle className="text-3xl font-bold text-gray-900">
                Recuperar Senha
              </CardTitle>
              <CardDescription className="text-lg text-gray-600">
                Digite o seu email e enviaremos um link para você redefinir sua
                senha.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              {/* Alert */}
              {showAlert && (
                <Alert className="border-green-200 bg-green-50">
                  <AlertDescription className="text-green-800">
                    Email enviado com sucesso! Cheque sua caixa de SPAM caso não
                    consiga encontrar seu email! Fique atento!
                  </AlertDescription>
                </Alert>
              )}

              {/* Form */}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-2">
                  <Label
                    htmlFor="email"
                    className="text-base font-medium text-gray-700"
                  >
                    Endereço de Email
                  </Label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={handleEmailChange}
                    required
                    className="h-11 border-gray-200 focus:border-[#24324D] focus:ring-[#24324D]"
                  />
                </div>

                <Button
                  type="submit"
                  disabled={isLoading}
                  className="w-full h-11 bg-[#24324D] hover:bg-[#1a2538] text-white font-medium transition-colors disabled:opacity-50"
                >
                  {isLoading ? "Enviando..." : "Enviar link de recuperação"}
                </Button>
              </form>

              {/* Back to login link */}
              <div className="text-center">
                <Link
                  to="/login"
                  className="text-base text-[#24324D] hover:text-[#1a2538] hover:underline transition-colors"
                >
                  Voltar para o login
                </Link>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
